import { ExportOptions, ExportPayloadSection } from '../types';
import resolveCellValue from './resolveCellValue';

// An empty value stays empty, without formatValue's '-' placeholder or a prefix/suffix.
const resolveTextCellValue = (
  row: Record<string, unknown>,
  column: ExportPayloadSection['columns'][number],
  options: ExportOptions
): string => {
  const rawValue = row[column.name];

  if (rawValue === null || rawValue === undefined || rawValue === '') {
    return '';
  }

  return resolveCellValue(row, column, options);
};

export default resolveTextCellValue;
